export default __webpack_public_path__ + "static/media/rgs_main_large.fba0e68c.jpg";